import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlinkoBetSectionComponent } from './plinko-bet-section/plinko-bet-section.component';
import { PlinkoBoardComponent } from './plinko-board/plinko-board.component';

@Component({
  selector: 'app-plinko',
  templateUrl: './plinko.component.html',
  styleUrls: ['./plinko.component.scss'],
  standalone: true,
  imports: [PlinkoBetSectionComponent, PlinkoBoardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlinkoComponent {}
